import { render, staticRenderFns } from "./VDesigningVersionSelector.vue?vue&type=template&id=d42c2202&"
import script from "./VDesigningVersionSelector.vue?vue&type=script&lang=ts&"
export * from "./VDesigningVersionSelector.vue?vue&type=script&lang=ts&"
import style0 from "./VDesigningVersionSelector.vue?vue&type=style&index=0&id=d42c2202&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports